import * as React from "react";
const LogoIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={"100%"}
    height={"100%"}
    viewBox="0 0 23 22"
    fill="none"
    {...props}
  >
    <path
      fill="#11302D"
      d="M20.142 10.422h-2.604V5.336l-4.364 2.307c-.61.32-1.172.72-1.674 1.191A7.628 7.628 0 0 0 9.826 7.64L5.462 5.333v5.086H2.858A2.077 2.077 0 0 0 .78 12.496v9.254h5.922V7.397L9.243 8.74c.517.273.995.616 1.42 1.019a7.677 7.677 0 0 0-1.593 4.686v7.306h4.854v-7.306a7.665 7.665 0 0 0-1.593-4.686 6.408 6.408 0 0 1 1.42-1.02l2.54-1.34V21.75h5.924v-9.253a2.077 2.077 0 0 0-2.073-2.075ZM5.462 20.506H2.027v-8.01a.832.832 0 0 1 .83-.83h2.605v8.84Zm7.222-6.062v6.062h-2.368v-6.062c0-1.334.413-2.636 1.183-3.725a6.431 6.431 0 0 1 1.185 3.725Zm8.286 6.062h-3.432v-8.84h2.604a.832.832 0 0 1 .831.83l-.003 8.01Z"
    />
    <path
      fill="#11302D"
      d="M11.5.817a2.841 2.841 0 1 0 0 5.682 2.841 2.841 0 0 0 0-5.682Zm0 4.441a1.597 1.597 0 1 1 1.597-1.597A1.6 1.6 0 0 1 11.5 5.255v.003Z"
    />
  </svg>
);
export default LogoIcon;
